// TOP LEVEL IMPORTS
import gql from 'graphql-tag';

export default gql`
  fragment lineItemFragment on LineItem {
    _id
    __typename
    title
    description
    currency
    #organization {
    #  ...organizationFragment
    #}
    amount
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Fragments/lineItemFragment.js